import { format } from 'date-fns'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import avatarPlaceholderSrc from 'shared/assets/images/avatar-placeholder.png'
import { LastUpdateFragment } from 'data/layoutcreator/queries/projects'
import { ReactChildren } from 'shared/types/global'
import { FragmentType, getFragmentData } from 'shared/types/layoutcreator'
import { Maybe } from 'shared/types/layoutcreator/graphql'

const Container = styled.div`
  flex-grow: 1;
  padding: 24px 24px 16px;
  border: 1px solid ${({ theme }) => theme.color.base.c2};
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background: ${({ theme }) => theme.color.base.c0};
`

const Title = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
  font-size: 18px;
  font-weight: 600;
`

const LastUpdate = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.base.c5};
  font-size: 11px;
`

const Avatar = styled.img`
  width: 16px;
  height: 16px;
  margin-right: ${({ theme }) => theme.spacing.tiny};
  overflow: hidden;
  border-radius: 50%;
`

type MetaProps = {
  title?: string
  lastUpdate?: Maybe<FragmentType<typeof LastUpdateFragment>>
} & ReactChildren

const Meta = ({ title, lastUpdate, children }: MetaProps) => {
  const { formatMessage } = useIntl()
  const lastUpdateFragment = getFragmentData(
    LastUpdateFragment,
    lastUpdate
  )
  return (
    <Container>
      <Title>{title}</Title>
      {lastUpdateFragment && (
        <LastUpdate>
          <Avatar
            src={lastUpdateFragment.avatarUrl || avatarPlaceholderSrc}
            alt={lastUpdateFragment.name}
          />
          {formatMessage(
            {
              id: 'YearbookCard.last.updated'
            },
            {
              date: format(
                new Date(lastUpdateFragment.updatedAt),
                'dd.MM.yy — hh:mm'
              )
            }
          )}
        </LastUpdate>
      )}

      {children}
    </Container>
  )
}

export default Meta
